import { trackPageView } from 'api/mixpanel';
import { getContext } from 'redux-saga/effects';
import { jwtDecode } from 'jwt-decode';
import { safeSessionStorage } from 'utils/safeStorage';
import { getParsedCookie } from '../../utils/cookie';
import { isAlive } from '../../store/features/auth/utils/sessionCookie';
import { Expirable } from '../../store/features/auth/types';

const currentPageKey = 'currentPage';

const getAccessToken = () => {
  const next: any = getContext('next');
  const parsedCookie = getParsedCookie(next);

  if (parsedCookie.access) {
    const access = jwtDecode(parsedCookie.access);
    if (isAlive(access as Expirable)) return parsedCookie.access;
  }
};

export function trackPage(currentPage: string, params?: {}, shouldTrack = true) {
  const prevPage = safeSessionStorage.getItem(currentPageKey) || 'Entry';
  const accessToken = getAccessToken();

  if (shouldTrack) {
    const trackPage = async () => {
      try {
        (window as any).mixpanel?.track('Mixpanel Page Viewed', {
          source: prevPage,
          page_name: currentPage,
          ...params,
          'Logged Status': accessToken ? 'Logged In' : 'Logged Out',
        });
        await trackPageView({
          ...(accessToken && {
            headers: {
              Authorization: `JWT ${accessToken}`,
            },
          }),
          body: {
            event_name: 'Page Viewed',
            data: {
              page_name: currentPage,
              params: {
                source: prevPage,
                ...params,
              },
            },
          },
        });
      } catch (error) {
        console.error(error);
      }
    };
    trackPage().then(() => safeSessionStorage.setItem(currentPageKey, currentPage));
  } else {
    safeSessionStorage.setItem(currentPageKey, currentPage);
  }
}

export function trackButtonClick(eventName: string, buttonName: string, params?: {}) {
  const accessToken = getAccessToken();

  try {
    trackPageView({
      ...(accessToken && {
        headers: {
          Authorization: `JWT ${accessToken}`,
        },
      }),
      body: {
        event_name: eventName,
        data: {
          button: buttonName,
          ...params,
        },
      },
    });
  } catch (error) {
    console.error(error);
  }
}
